import isArray from 'lodash/isArray';
import React from 'react';

export function isString(value) {
	return typeof value === 'string';
}

export function arrify(obj) {
	if (!obj) {
		return [];
	}

	if (isArray(obj)) {
		return obj;
	}

	return [obj];
}

export function resolve(object, path) {
	return path.split('.').reduce((prev, curr) => prev[curr], object || this);
}

export function getWindowSize() {
	var w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0],
		x = w.innerWidth || e.clientWidth || g.clientWidth,
		y = w.innerHeight|| e.clientHeight|| g.clientHeight;

	return {width: x, height: y}
}

const newlineRegex = /(\r\n|\r|\n)/g;
export function nl2br(str) {
	if (typeof str === 'number') {
		return str;
	} else if (typeof str !== 'string') {
		return '';
	}

	return str.trim().split(newlineRegex).map(function(line, index) {
		if (line.match(newlineRegex)) {
			return React.createElement('br', { key: index });
		}
		return line;
	});
}


// WEBPACK FOOTER //
// ./src/utils/utils.js